import React from 'react';
import { QuickService } from 'services/caller-id';
import { CloseIcon } from './icons';
import { initialsOf, TAG_PALETTES } from './use-day-availability';

interface ServiceSheetProps {
  services: QuickService[]; // quick-service catalog (GET service/quickBooking)
  selected: number[]; // selected quick-service ids
  onToggle: (id: number) => void;
  onClose: () => void;
}

// Service picker bottom sheet within the booking page (checkbox rows over the
// quick-service catalog, accent "Xong" footer).
const ServiceSheet = ({ services, selected, onToggle, onClose }: ServiceSheetProps) => (
  <>
    <div className="cid-form-scrim" onClick={onClose} />
    <div className="cid-service-sheet">
      <div className="cid-sheet-grab"><span /></div>
      <div className="cid-subsheet-header">
        <span className="cid-subsheet-title">Select services</span>
        <button type="button" className="cid-sheet-close" onClick={onClose}><CloseIcon size={17} /></button>
      </div>
      <div className="cid-service-options">
        {services.map((svc, i) => {
          const on = selected.includes(svc.id);
          const palette = TAG_PALETTES[i % TAG_PALETTES.length];
          return (
            <label key={svc.id} className="cid-service-option" onClick={e => { e.preventDefault(); onToggle(svc.id); }}>
              <span className="cid-service-dot" style={{ background: palette.bg, color: palette.fg }}>{initialsOf(svc.serviceName)}</span>
              <span className="cid-service-label">{svc.serviceName}</span>
              <span className={`cid-service-checkbox ${on ? 'on' : ''}`}>
                <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: on ? 1 : 0 }}><path d="m20 6-11 11-5-5" /></svg>
              </span>
            </label>
          );
        })}
      </div>
      <div className="cid-service-footer">
        <button type="button" className="cid-btn-done" onClick={onClose}>Xong</button>
      </div>
    </div>
  </>
);

export default ServiceSheet;
